import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MarketplaceRfq } from '~proto/marketplace/rfq_pb';
import { MarketplaceRfqStatus } from '~proto/types/types_pb';
import { MarketplaceService } from '~services/marketplace.service';

@Component({
  selector: 'ct-marketplace-awarded-rfq',
  styleUrls: ['./marketplace-awarded-rfq.component.scss'],
  templateUrl: './marketplace-awarded-rfq.component.html',
})
export class MarketplaceAwardedRfqComponent implements OnInit, OnDestroy {
  constructor(private marketplaceService: MarketplaceService) {}
  public awardedRfq$$ = new BehaviorSubject<MarketplaceRfq.AsObject[]>(null);
  public rfqTypes = MarketplaceRfqStatus;

  public ngOnInit() {
    this.marketplaceService.allRFQ$.subscribe((rfqs: MarketplaceRfq.AsObject[]) => {
      this.awardedRfq$$.next(
        (rfqs && rfqs.filter((rfq) => rfq.status === MarketplaceRfqStatus.RFQ_STATUS_AWARDED)) || null,
      );
    });
  }
  public ngOnDestroy() {
    // this.marketplaceService.clearSelectedRfq();
  }
}
